import React from 'react';
import './FAQ.css';

const FAQ = () => {
  const faqs = [
    {
      question: "Where is the wedding?",
      answer: "The wedding will be held in Phuket, Thailand at The Surin Phuket."
    },
    {
      question: "What day is the wedding?",
      answer: "January 16th, 2027"
    },
    {
      question: "What time is the ceremony?",
      answer: "Late afternoon, approximately 4 PM. Ends at midnight."
    },
    {
      question: "Is this a beach wedding?",
      answer: "Yes, this is a beach wedding."
    },
    {
      question: "What is the dress code?",
      answer: (
        <>
          Our wedding will be held outdoors on the beach at sunset. We kindly ask guests to wear elegant, formal attire in lightweight fabrics suitable for warm weather, and to choose footwear appropriate for sand.
          <br /><br />
          <strong>Men:</strong> Please wear a suit. Ties are optional.
          <br />
          <strong>Women:</strong> We encourage you to wear your best dress. Please do not wear a white dress.
        </>
      )
    },
    {
      question: "Is there a color theme?",
      answer: "Our wedding colors are dusty rose and gold. There is no need to match the color theme, but if you would like to coordinate, you are very welcome to!"
    },
    {
      question: "Is there a registry?",
      answer: "We do not have a registry: your presence is all we ask for! If you wish to bring something, we would cherish a card with your well wishes!"
    },
    {
      question: "Is this an adults-only wedding?",
      answer: "Nope! Folks of all ages are welcome here!"
    },
    {
      question: "Is the wedding at a resort?",
      answer: "Yes, but staying on-site is not required; see the Accommodations tab."
    },
    {
      question: "Are there events on other days?",
      answer: "There may be optional welcome and/or farewell events. Details to follow."
    },
    {
      question: "How many days should I plan to attend?",
      answer: "Our wedding is just one day. However, international guests may want to stay a couple days to account for jet lag."
    },
    {
      question: "Do I need a passport?",
      answer: "If you are traveling from outside Thailand, a valid passport is required. Local guests do not need a passport."
    },
    {
      question: "When will more details be available?",
      answer: "More details will be shared in the coming months. Guests who RSVP will be contacted when more information becomes available, and information will also be posted here as it becomes available"
    }
  ];

  // Google Maps links for The Surin Phuket
  const googleMapsLink = "https://www.google.com/maps/search/?api=1&query=The+Surin+Phuket+118+Soi+Hat+Surin+8+Choeng+Thale+Thalang+District+Phuket+Thailand";
  // Using a simple embed that will work - you can get the actual embed code from Google Maps by searching for the location
  // For now, using a search-based embed URL
  const googleMapsEmbed = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3951.1719049990984!2d98.27519187591973!3d7.981175492044063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x305039973f859a3d%3A0x4fca1f8fd01767e6!2sThe%20Surin%20Phuket!5e0!3m2!1sen!2sus!4v1770016873766!5m2!1sen!2sus`;

  return (
    <section id="faq" className="faq section">
      <div className="container">
        <h2 className="section-title">FAQ</h2>
        
        <div className="faq-content">
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <React.Fragment key={index}>
                <div className="faq-item">
                  <p className="faq-question">{faq.question}</p>
                  <div className="faq-answer">{faq.answer}</div>
                </div>
                {index === 0 && (
                  <div className="faq-map-container">
                    <a
                      href={googleMapsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="faq-map-link"
                      title="Open in Google Maps"
                    >
                      <iframe
                        className="faq-map"
                        src={googleMapsEmbed}
                        width="100%"
                        height="400"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="The Surin Phuket Location"
                      ></iframe>
                    </a>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
